import type { IconNode } from '../types';

/**
 * @name cabin
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMi42IDEwLjRhMi4xMiAyLjEyIDAgMSAwIDMuMDIgMi45OEwxMiA3bDYuNCA2LjRhMi4xMiAyLjEyIDAgMSAwIDIuOTc5LTMuMDIxTDEzLjcgMi43YTIuNCAyLjQgMCAwIDAtMy40MDQuMDA0WiIgLz4KICA8cGF0aCBkPSJNMTQgMjJ2LTdhMiAyIDAgMCAwLTQgMHY3IiAvPgogIDxwYXRoIGQ9Ik0xNCAxNGg2djZhMiAyIDAgMCAxLTIgMkg2YTIgMiAwIDAgMS0yLTJ2LTZoNiIgLz4KICA8cGF0aCBkPSJNNCAxOGg2IiAvPgogIDxwYXRoIGQ9Ik0xNCAxOGg2IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/cabin
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const cabin: IconNode = [
  [
    'path',
    {
      d: 'M2.6 10.4a2.12 2.12 0 1 0 3.02 2.98L12 7l6.4 6.4a2.12 2.12 0 1 0 2.979-3.021L13.7 2.7a2.4 2.4 0 0 0-3.404.004Z',
      key: 'lwty51',
    },
  ],
  ['path', { d: 'M14 22v-7a2 2 0 0 0-4 0v7', key: '11fco7' }],
  ['path', { d: 'M14 14h6v6a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-6h6', key: '5zg1u1' }],
  ['path', { d: 'M4 18h6', key: '1jikk7' }],
  ['path', { d: 'M14 18h6', key: '1m8k6r' }],
];

export default cabin;
